export const texts = {
  english: {
    chooseLoginOption: "Choose your preferred identification method",
    validation_er: {
      missing_address: "Address is Missing",
      missing_phone: "Phone Number is Missing",
      missing_email: "Email Address is Missing",
    },
    confirm: "Confirm",
    addres_english_only: "Please type the address using only English letters",
    conutryCode: "Country Code",
    paneemConfirm: {
      par1: "Thank you for using PANEEM.",
      par2: "All steps are now complete, and you may close the app.",
      par3: "Should we need anything else from you, we will be in touch.",
      par4: "To create an account with the Claims Conference where your personalized information and dedicated services will be available to you 24/7",
      par5: "Click here",
    },
    contactInfoConfirm: {
      par1: "Thank you for updating your contact information.",
      par2: "To create an account with the Claims Conference where your personalized information and dedicated services will be available to you 24/7",
      par3: "Click here",
    },
    email_or_phone_requered: "Please enter either an email address or a phone number to continue.",
    textDirection: "ltr",
    language: "english",
    form: "During this procedure you will be able to certify your identity by taking a picture of your face and taking a picture of your government issued photo identity document (Passport, driver’s license, or national ID). This system is secured and complies with international data protections and regulations (For more information: read the terms and conditions, provided during the process of verification). PANEEM is intended for official use only.",
    formGreeting: "Welcome to the Claims Conference PANEEM app.",
    startValidation: "Click to continue",
    regNum: "Registration Number",
    israeliId: "Israeli ID",
    israeliId_RESIDENTS: "Israeli ID FOR ISRAEL RESIDENTS ONLY",
    israeliIdDesc: "Should be exactly 9 digits long",
    regNumDesc: "Should be exactly 6 - 7 digits long",
    regNumTooltip:
      "This is the seven-digit Claims Conference registration number that was provided to you when you first applied for services or compensation payments. You will also find it in the reference line of any correspondence from the Claims Conference.",
    regNumError: "Registration number is less than 6 - 7 digits.",
    birthDate: "Date of birth",
    birthDateError: "Date invalid.",
    completion:
      "Thank you for using PANEEM. All steps are now complete, and you may close the app. Should we need anything else from you, we will be in touch.",
    confirm_info: [
      "Thank you for using Paneem,",
      "you have successfully completed your verification process",
      "Please take a moment to confirm or update your contact details below.",
    ],
    startVerification: "Start verification",
    agreeTermsNotice: "Agree to the terms and conditions",
    idsNotice: `Passport, Driver's license or National ID card`,
    termsText: "I have read and agree to the terms and conditions.",
    insertEmailTitle: "Enter your contact details",
    verificationNotice: "Prepare for your verification",
    consentMsg: "Agree to give us consent",
    url: "https://www.claimscon.org/about/privacy-policy/",
    contactVia: "Contact via:",
    phone: "Phone number",
    isSMS: "Can your phone receive SMS messages?",
    yes: "Yes",
    no: "No",
    country: "Choose your country",
    emailLabel: "Email",
    emailExample: "example@example.com",
    consentText:
      "I consent to my photograph being taken and my likeness and identity document being converted to an algorithm and used to validate my identity.",
    privacyPolicy:
      "I understand that this information will be transferred to The Claims Conference and certain third parties and used and stored in accordance with the Privacy Policy.",
    captureFace: "Tap the screen to capture face.",
    captureDoc: "Tap the screen to capture document.",
    nextStep:
      "The next step is to take a photograph of your identity document. Make sure that the whole document is visible (document is not cut off) and that the document appears close enough to fill the screen and is readable on the image.",
    frameFaceOval: "Please frame your face in the oval.",
    frameFaceScreen: "Please frame your face on the screen.",
    send: "Send",
    retake: "Retake",
    capture: "Take photo",
    isDocBack: "Does your document have a back side?",
    docBack: "Position the back side of the document so it is fully visible.",
    tryAgain: "Please follow the instructions and try again",
    TakePhotoBackSide: "Take a Photo of the Back Side of Your Identity Document",
    TakePhotoDocument: "Take a Photo of Your Identity Document",
    FrameBackSide: "Frame the Back Side of the Document",
    FrameDocument: "Frame Your Identity Document",
    welcome: "Welcome to PANEEM",
    followInstructions: "Please follow the instructions on screen for taking a photo of you and your identity document",
    confirmImage: "Please confirm the image",
    documentVisible:
      "Make sure that the whole document is visible (document is not cut off) and that the document appears close enough to fill the screen and is readable on the image",
    matchingError: "There was a matching issue",
    documentVisibleError:
      "Make sure the whole document is visible. (document not cut off) Make sure the document appears close enough to fill the screen and is readable",
    tryAgainShort: "Try again",
    continue: "Continue",
    somethingWentWrong: "Something went wrong",
    internetConnection: "Please make sure your internet connection is stable",
    FAQ: "Frequently asked questions",
    instructions: "Instructions",
    statusCheck: "Status check",
    login_clientID: "Agencies Portal",
    paneem_not_availble: [
      "The PANEEM application is currently under maintenance.",
      "We apologize for any inconveniences this may cause.",
      "The application will be accessible shortly, please refresh the page in a few minutes.",
      "We appreciate your understanding and patience.",
    ],
    update: "Update",
    cancel: "Cancel",
    oops: "Oops! Something went wrong and your request didn't go through. Please alert our team and try again later.",
    formsFeilds: {
      phone: "Phone Number",
      email: "Email Address",
      addressTitle: "Address",
      address: "Address/Street/Building/Apt",
      street: "Street",
      building: "Building",
      apt: "Apt",
      country: "Country",
      city: "City",
      state: "Region/State/Provence",
      zipcode: "Postal Code",
    },
    illigble_address: "Please provide full address details, including street, city, and country.",
    fill_reg_fields: "Oops! Something went wrong. Please fill in the address manually.",
    only_english: "Should contain only English letters",
    find_address: "Find Address",
    select_address: "Select an address from the list",
    validation: {
      req_feild: "Required Field",
      not_number: "Should not contain digits",
      only_number: "Should contain only digits",
      digits_char: "Please enter a valid zipcode",
    },
    error_finding_camera:
      "Unable to access the camera. Please ensure it's connected and not in use by another application, then try again",
    of_3_attempts: "of 3 attempts",
    dont_give_up: "DON'T GIVE UP!",
    threeAttempts: "You have 3 attempts to complete the process",
    howToIdentify: "How would you like to identify?",
    regulaLocale: "en",
    previouslyVerified: "Previously verified with PANEEM",
    firstTime: "First time or not verified with PANEEM",
    havingTrouble: "Do you need more time?",
    paneemDisabled: [
      "The PANEEM service will be unavailable from December 18 to December 31, 2025, as we prepare for the 2026 Proof of Life cycle.",
      "Please come back on or after January 1, 2026, to complete your 2026 PANEEM submission.",
    ],
    cantCapture: "We were unable to automatically take your photo",
    manualPhoto: "Take a photo manually",
  },

  hebrew: {
    chooseLoginOption: "בחר את שיטת הזיהוי המועדפת עליך",
    israeliId_RESIDENTS: "תעודת זהות - מיועדת לתושבי ישראל בלבד",
    israeliId: "תעודת זהות",
    israeliIdDesc: "חייב להיות בדיוק באורך של 9 ספרות",
    validation_er: {
      missing_address: "חסרה כתובת",
      missing_phone: "חסר מספר טלפון",
      missing_email: "חסר כתובת אימייל",
    },
    confirm: "אשר",
    addres_english_only: "אנא הקלד את הכתובת באותיות אנגליות בלבד",
    conutryCode: "קוד מדינה",
    paneemConfirm: {
      par1: "תודה על שימושך ב-PANEEM.",
      par2: "כל השלבים הושלמו, ותוכל/י לסגור את האפליקציה.",
      par3: "אם נזדקק למשהו נוסף ממך, ניצור איתך קשר.",
      par4: "ליצירת חשבון ב-Claims Conference שבו מידע אישי ושירותים מוקדשים יהיו זמינים לך 24/7",
      par5: "לחץ כאן",
    },
    contactInfoConfirm: {
      par1: "תודה שעדכנת את פרטי הקשר שלך.",
      par2: "כדי ליצור חשבון עם ה-Claims Conference, שבו מידע אישי ושירותים מוקדשים יהיו זמינים לך 24/7",
      par3: "לחץ כאן",
    },
    textDirection: "rtl",
    language: "hebrew",
    email_or_phone_requered: 'נא להזין כתובת דוא"ל או מספר טלפון כדי להמשיך.',
    form: "בתהליך זה תוכלו לאמת את זהותכם בעזרת צילום הפנים שלכם ומסמך ממשלתי עם תמונה (פספורט, רישיון נהיגה, או תעודת זהות). המערכת מאובטחת ועומדת בתקנון אבטחת מידע בין לאומי (למידע נוסף: קיראו את התנאים, בזמן תהליך הזיהוי). PANEEM נועדה לשימוש רשמי בלבד.",
    formGreeting: "PANEEM של ועידת התביעות.",
    startValidation: "לחצו כדי להמשיך",
    regNum: "מספר רישום",
    regNumDesc: "בדיוק 6 - 7 ספרות",
    regNumTooltip:
      "שבע ספרות הניתנו לכם כאשר הגשתם לראשונה בקשה לשירותים או תשלומי פיצויים. תמצאו אותן בשורת ההתייחסות בכל התכתבות מועידת התביעות.",
    regNumError: "מספר זיהוי פחות מ-6 - 7 ספרות.",
    birthDate: "יום הולדת",
    birthDateError: "תאריך לא תקין.",
    completion:
      "תודה על השימוש ב- PANEEM. כל השלבים הושלמו, ואפשר לסגור את האפליקציה. אם נצטרך מכם משהו נוסף, ניצור קשר.",
    confirm_info: [
      "תודה שהשתמשת בפנים,",
      "השלמת בהצלחה את תהליך האימות שלך.",
      "אנא הקדש רגע כדי לאשר או לעדכן את פרטי הקשר שלך למטה.",
    ],

    startVerification: "התחילו בהליך האימות",
    agreeTermsNotice: "הסכימו לתנאים ולהתניות",
    idsNotice: "דרכון, רישיון נהיגה או תעודת זהות",
    termsText: "קראתי והסכמתי לתנאי השימוש.",
    insertEmailTitle: "הזן את פרטי ההתקשרות שלך",
    verificationNotice: "התכונן לתהליך אימות",
    consentMsg: "מסכים לתת לנו הסכמה",
    url: "https://he.claimscon.org/about/privacy-policy/",
    contactVia: "צור קשר בעזרת:",
    phone: "מספר טלפון",
    isSMS: "האם הטלפון שלכם מקבל מסרונים?",
    yes: "כן",
    no: "לא",
    country: "בחר את המדינה שלך",
    emailLabel: "אימייל",
    emailExample: "example@example.com",
    consentText: "אני מסכים לצלם תמונה שלי ולהמיר את מסמך הזהות שלי וההתאמה שלי לאלגוריתם בכדי לשמש לאימות הזהות שלי.",
    privacyPolicy:
      "אני מבין שמידע זה יועבר לוועידת התביעות ולצדדים שלישיים מסוימים, וישמש ויישמר בהתאם למדיניות להגנת הפרטיות.",
    captureFace: "הקש על המסך כדי לצלם פנים.",
    captureDoc: "הקש על המסך כדי לצלם מסמך.",
    nextStep: `.השלב הבא הוא לצלם את התעודה המזהה שלכם
      אנא וודאו כי כל התעודה נראת (התעודה לא חתוכה) והתעודה קרובה מספיק למלא את המסך וניתן לקרוא אותה`,
    frameFaceOval: "אנא מקם את פניך בעיגול",
    frameFaceScreen: "אנא מקם את פניך על המסך",
    send: "שלחו",
    retake: "צלמו שוב",
    capture: "צלם תמונה",
    isDocBack: "האם למסמך שלך יש צד אחורי?",
    docBack: "מקם את הצד האחורי של המסמך כך שהוא יהיה נראה לחלוטין.",
    tryAgain: "אנא עקוב אחר ההוראות ונסה שוב",
    TakePhotoBackSide: "צלם\\י תמונה של הצד האחורי של התעודה המזהה שלך",
    TakePhotoDocument: "צלם\\י תמונה של התעודה המזהה שלך",
    FrameBackSide: "ודא\\י כי הצד האחורי של התעודה המזהה בתוך המסגרת",
    FrameDocument: "ודא\\י כי התעודה המזהה שלך בתוך המסגרת",
    welcome: "ברוכים הבאים לפנים",
    followInstructions: "אנא מלא\\י אחר ההוראות שיופיעו על המסך המסבירות כיצד לצלם את הניצול ואת המסמך המזהה",
    confirmImage: "אנא אשר\\י את התמונה",
    documentVisible:
      "אנא ודא\\י כי המסמך המזהה מופיע בתמונה בשלמותו (המסמך אינו קטוע בתמונה) וכי המסמך קרוב מספיק כך שהוא ממלא את כל התמונה וניתן לקרא את הכיתוב",
    matchingError: "הייתה בעיה בהתאמה",
    documentVisibleError:
      "אנא ודא\\י כי המסמך המזהה מופיע בתמונה בשלמותו (המסמך אינו קטוע בתמונה) וכי המסמך קרוב מספיק כך שהוא ממלא את כל התמונה וניתן לקרא את הכיתוב",
    tryAgainShort: "נסה שנית",
    continue: "המשך",
    somethingWentWrong: "משהו השתבש",
    internetConnection: "אנא ודא\\י כי חיבור האינטרנט שלך יציב",
    FAQ: "שאלות נפוצות",
    instructions: "הוראות",
    statusCheck: "בדיקת סטטוס",
    login_clientID: "פורטל סוכנויות",
    paneem_not_availble: [
      "אפליקצית PANEEM נמצאת כעת בתחזוקה.",
      "אנו מתנצלים על אי הנוחות שעלולה להיגרם.",
      "האפליקציה תהיה זמינה בקרוב, נא לרענן את הדף בעוד מספר דקות.",
      "אנו מעריכים את ההבנה והסבלנות.",
    ],
    update: "עדכון",
    cancel: "ביטול",
    oops: "אופס! משהו השתבש והבקשה שלך נכשלה. אנא עדכן את צוות התמיכה שלנו ונסה שוב מאוחר יותר.",
    formsFeilds: {
      phone: "מספר טלפון",
      email: 'כתובת דוא"ל',
      addressTitle: "כתובת",
      address: "כתובת/רחוב/בניין/דירה",
      street: "רחוב",
      building: "בניין",
      apt: "דירה",
      country: "מדינה",
      city: "עיר",
      state: "אזור/מדינה/נפה",
      zipcode: "מיקוד",
    },
    illigble_address: "נא לספק פרטי כתובת מלאים, כולל רחוב, עיר ומדינה.",
    fill_reg_fields: "אופס! משהו השתבש. אנא מלא את הכתובת ידנית.",
    only_english: "יש להשתמש באותיות אנגליות בלבד",
    find_address: "מצא כתובת",
    select_address: "בחר כתובת מהרשימה",
    validation: {
      req_feild: "שדה חובה",
      not_number: "אין לכלול ספרות",
      only_number: "יש לכלול ספרות בלבד",
      digits_char: "אנא הזן מיקוד חוקי",
    },
    error_finding_camera: "לא ניתן לגשת למצלמה. אנא ודא שהיא מחוברת ולא בשימוש על ידי יישום אחר, ואז נסה שוב",
    of_3_attempts: "מתוך 3 ניסיונות",
    dont_give_up: "אל תוותר!",
    threeAttempts: "יש לך 3 ניסיונות להשלים את התהליך",
    howToIdentify: "איך תרצה להזדהות?",
    regulaLocale: "he",
    previouslyVerified: "כבר מאומת עם PANEEM",
    firstTime: "פעם ראשונה או לא מאומת עם PANEEM",
    havingTrouble: "האם הנך צריך/ה עוד זמן?",
    paneemDisabled: [
      "שירות Paneem לא יהיה זמין בין ה-18 בדצמבר ל-31 בדצמבר 2025, בזמן שאנו מתכוננים למחזור הוכחת החיים לשנת 2026.",
      "אנא חזרו החל מה-1 בינואר 2026 , כדי להשלים את הגשת Paneem לשנת 2026.",
    ],
    cantCapture: "לא הצלחנו לצלם את התמונה שלך באופן אוטומטי",
    manualPhoto: "לצלם את התמונה באופן ידני",
  },

  russian: {
    chooseLoginOption: "Выберите предпочтительный метод идентификации",
    israeliId: "Номер Тэудат Зеут",
    israeliId_RESIDENTS: "Номер Тэудат Зеут - Только для израильских граждан",
    israeliIdDesc: "Должен содержать ровно 9 цифр",
    validation_er: {
      missing_address: "Адрес отсутствует",
      missing_phone: "Номер телефона отсутствует",
      missing_email: "Электронная почта отсутствует",
    },
    confirm: "Подтвердить",
    addres_english_only: "Пожалуйста, введите адрес только латинскими буквами",
    conutryCode: "Код страны",
    contactInfoConfirm: {
      par1: "Спасибо за обновление Ваших контактных данных.",
      par2: "Чтобы создать учетную запись в Claims Conference, где Ваша персонализированная информация и выделенные услуги будут доступны Вам 24/7",
      par3: "Нажмите здесь",
    },
    paneemConfirm: {
      par1: "Спасибо за использование PANEEM.",
      par2: "Все этапы завершены, Вы можете закрыть приложение.",
      par3: "Если нам потребуется что-то еще, мы свяжемся с Вами.",
      par4: "Для создания учетной записи в Claims Conference, где Ваша персонализированная информация и индивидуальные услуги будут доступны 24/7",
      par5: "Нажмите здесь",
    },
    textDirection: "ltr",
    language: "russian",
    email_or_phone_requered: "Пожалуйста, введите адрес электронной почты или номер телефона для продолжения.",
    form: "В ходе этой процедуры, у Вас будет возможность пройти верификацию личности, сделав фотографию лица, а также фотографию удостоверения личности(паспорт, водительские права или удостоверение государственного образца).Эта система защищена и соответствует международным стандартам и правилам безопасности данных.Для получения более подробной информации, ознакомьтесь с положениями и условиями, которые станут доступны в процессе верификации.PANEEM предназначена исключительно для официального использования.",
    formGreeting: "Добро пожаловать в приложение Claims Conference PANEEM.",
    startValidation: "Нажмите чтобы продолжить",
    regNum: "Регистрационный номер",
    regNumDesc: "Должен состоять из 6 - 7 цифр",
    regNumTooltip:
      "Это – семизначный Регистрационный номер Claims Conference, предоставленный Вам, когда Вы впервые обратились за обслуживанием или компенсацией.Этот номер также будет указан в любой корреспонденции, полученной от Claims Conference.",
    regNumError: "Регистрационный номер состоит из менее, чем 6 - 7 цифр.",
    birthDate: "Дата рождения",
    birthDateError: "Неверная дата.",
    completion:
      "Благодарим Вас за использование PANEEM. Все необходимые действия выполнены, Вы можете закрыть приложение. Если от Вас потребуется что-то ещё, мы с Вами свяжемся.",
    confirm_info: [
      "Спасибо, что используете PANEEM,",
      "Вы успешно завершили процесс проверки.",
      "Пожалуйста, найдите время, чтобы подтвердить или обновить свои контактные данные ниже.",
    ],

    startVerification: "Приступить к подтверждению личности",
    agreeTermsNotice: "Согласиться с условиями",
    idsNotice:
      "Заграничный паспорт, водительское удостоверение или удостоверение личности государственого образца личности",
    termsText: "Я прочитал(а) и принимаю условия пользовательского соглашения.",
    insertEmailTitle: "Введите свою контактную информацию",
    verificationNotice: "Подготовьтесь к верификации",
    consentMsg: "Вы даете нам согласие",
    url: "https://ru.claimscon.org/about/privacy-policy/",
    contactVia: "Способ связи:",
    phone: "Номер телефона",
    isSMS: "Принимает ли Ваш телефон SMS?",
    yes: "да",
    no: "нет",
    country: "Выберите свою страну",
    emailLabel: "Адрес электронной почты",
    emailExample: "example@example.com",
    consentText:
      "Я выражаю согласие на фотосъемку и на то, чтобы мое изображение и документ использовались для верификации моей личности при помощи алгоритма.",
    privacyPolicy:
      "Я понимаю, что эта информация будет передана Клеймс Конференс и ряду третьих лиц и будет использоваться и храниться в соответствии с политикой конфиденциальности.",
    captureFace: "Нажмите на экран, чтобы захватить лицо.",
    captureDoc: "Коснитесь экрана, чтобы захватить документ.",
    nextStep:
      "Следующий шаг: пожалуйста, сделайте фотографию Вашего удостоверения личности. Убедитесь, что документ полностью виден на экране (края не обрезаны) и вписан в него по размеру, а также хорошо читаем",
    frameFaceOval: "Пожалуйста, поместите свое лицо в овал.",
    frameFaceScreen: "Пожалуйста, поместите свое лицо в экран.",
    send: "Отправьте",
    retake: "Сделайте ещё раз",
    capture: "Сделайте фотографию",
    isDocBack: "Есть ли у Вашего документа обратная сторона?",
    docBack: "Расположите обратную сторону документа так, чтобы она была полностью видна.",
    tryAgain: "Пожалуйста, следуйте инструкциям и попробуйте снова",
    TakePhotoBackSide: "Сфотографируйте обратную сторону документа, удостоверяющего Вашу личность.",
    TakePhotoDocument: "Сфотографируйте документ, удостоверяющего Вашу личность.",
    FrameBackSide: "Вставьте в рамку обратную сторону документа, удостоверяющего Вашу личность.",
    FrameDocument: "Вставьте в рамку Ваш документ, удостоверяющего личность.",
    welcome: "Добро пожаловать в PANEEM",
    followInstructions:
      "Пожалуйста, следуйте инструкциям на экране, чтобы сфотографировать Вас и Ваш документ, удостоверяющего личность",
    confirmImage: "Пожалуйста, подтвердите изображение",
    documentVisible:
      "Убедитесь, что весь документ виден (документ не обрезан) и что документ отображается достаточно близко, чтобы заполнить экран, и четко виден на изображении",
    matchingError: "Возникла проблема совпадения",
    documentVisibleError:
      "Убедитесь, что весь документ виден (документ не обрезан). Убедитесь, что документ расположен достаточно близко, чтобы заполнить экран, и можно четко прочитать содержимое документa",
    tryAgainShort: "Попробуйте еще раз",
    continue: "Продолжить",
    somethingWentWrong: "Что-то пошло не так",
    internetConnection: "Пожалуйста убедитесь, что Ваше интернет-соединение стабильное",
    FAQ: "Часто задаваемые вопросы",
    instructions: "инструкции",
    statusCheck: "Проверка статуса",
    login_clientID: "Портал агентств",
    paneem_not_availble: [
      "Приложение PANEEM в настоящее время находится на техническом обслуживании.",
      "Приносим извинения за возможные неудобства.",
      "Приложение скоро будет доступно, пожалуйста, обновите страницу через несколько минут.",
      "Благодарим за понимание и терпение.",
    ],
    update: "Обновить",
    cancel: "Отмена",
    oops: "Ой! Что-то пошло не так, и Ваш запрос не был выполнен. Пожалуйста, сообщите нашей команде и попробуйте позже.",
    formsFeilds: {
      phone: "Номер телефона",
      email: "Адрес электронной почты",
      addressTitle: "Адрес",
      address: "Адрес/Улица/Дом/Квартира",
      street: "Улица",
      building: "Дом",
      apt: "Квартира",
      country: "Страна",
      city: "Город",
      state: "Регион/Штат/Провинция",
      zipcode: "Почтовый индекс",
    },
    illigble_address: "Пожалуйста, укажите полные данные адреса, включая улицу, город и страну.",
    fill_reg_fields: "Упс! Что-то пошло не так. Пожалуйста, заполните адрес вручную.",
    only_english: "Должно содержать только английские буквы",
    find_address: "Найти адрес",
    select_address: "Выберите адрес из списка",
    validation: {
      req_feild: "Обязательное поле",
      not_number: "Не должно содержать цифр",
      only_number: "Должно содержать только цифры",
      digits_char: "Пожалуйста, введите действительный почтовый индекс",
    },
    error_finding_camera:
      "Не удается получить доступ к камере. Пожалуйста, убедитесь, что она подключена и не используется другим приложением, затем попробуйте снова",
    of_3_attempts: "из 3 попыток",
    dont_give_up: "НЕ СДАВАЙТЕСЬ!",
    threeAttempts: "У Вас есть 3 попытки завершить процесс",
    howToIdentify: "Как бы вы хотели себя идентифицировать?",
    regulaLocale: "ru",
    previouslyVerified: "Ранее ваша личность уже проверялась в PANEEM",
    firstTime: "Впервые пользуетесь или не проходили проверку в PANEEM",
    havingTrouble: "Вам нужно больше времени?",
    paneemDisabled: [
      "Услуга Paneem будет недоступна с 18 декабря по 31 декабря 2025 года, так как мы готовимся к новому циклу подтверждения нахождения в живых в 2026 году.",
      "Пожалуйста, воспользуйтесь услугой Paneem начиная с 1 января 2026.",
    ],
    cantCapture: "Нам не удалось сделать вашу фотографию автоматически",
    manualPhoto: "Сделать фотографию в ручном режиме",
  },

  german: {
    chooseLoginOption: "Wählen Sie Ihre bevorzugte Identifikationsmethode",
    israeliId: "Israelische ID",
    israeliId_RESIDENTS: "Israelische ID NUR FÜR ISRAELISCHE EINWOHNER",
    israeliIdDesc: "Muss genau 9 Ziffern lang sein",
    validation_er: {
      missing_address: "Adresse fehlt",
      missing_phone: "Telefonnummer fehlt",
      missing_email: "E-Mail-Adresse fehlt",
    },
    confirm: "Bestätigen",
    addres_english_only: "Bitte geben Sie die Adresse nur in englischen Buchstaben ein",
    conutryCode: "Ländervorwahl",
    contactInfoConfirm: {
      par1: "Vielen Dank für das Aktualisieren Ihrer Kontaktdaten.",
      par2: "Um ein Konto bei der Claims Conference zu erstellen, wo Ihre persönlichen Informationen und speziellen Dienste rund um die Uhr verfügbar sind.",
      par3: "Klicken Sie hier",
    },
    paneemConfirm: {
      par1: "Vielen Dank für die Nutzung von PANEEM.",
      par2: "Alle Schritte sind abgeschlossen, Sie können die App nun schließen.",
      par3: "Sollten wir weitere Informationen von Ihnen benötigen, werden wir uns in Verbindung setzen.",
      par4: "Um ein Konto bei der Claims Conference zu erstellen, wo Ihre persönlichen Informationen und dedizierten Dienste rund um die Uhr verfügbar sind.",
      par5: "Hier klicken",
    },
    textDirection: "ltr",
    language: "german",
    email_or_phone_requered:
      "Bitte geben Sie entweder eine E-Mail-Adresse oder eine Telefonnummer ein, um fortzufahren.",
    form: "Während dieses Verfahrens können Sie Ihre Identität bestätigen, indem Sie ein Foto von Ihrem Gesicht und ein Foto Ihres staatlich ausgestellten Lichtbildausweises (Reisepass, Führerschein oder Personalausweis) machen. Dieses System ist gesichert und entspricht den internationalen Datenschutzbestimmungen (für weitere Informationen: lesen Sie die Allgemeinen Geschäftsbedingungen, die während des Verifizierungsprozesses bereitgestellt werden). PANEEM ist nur für den offiziellen Gebrauch bestimmt.",
    formGreeting: "Willkommen bei der PANEEM-App der Claims Conference.",
    startValidation: "Klicken Sie um fortzusetzen",
    regNum: "Registrierungsnummer",
    regNumDesc: "Muss genau 6 - 7 Ziffern lang sein",
    regNumTooltip:
      "Dies ist die siebenstellige Registrierungsnummer der Claims Conference, die Ihnen mitgeteilt wurde, als Sie zum ersten Mal einen Antrag auf Leistungen oder Entschädigungszahlungen gestellt haben. Sie finden sie auch in der Betreffzeile jeder Korrespondenz von der Claims Conference.",
    regNumError: "Registrierungsnummer ist weniger als 6 - 7 Ziffern.",
    birthDate: "Geburtsdatum",
    birthDateError: "Datum ungültig.",
    completion:
      "Danke, dass Sie an PANEEM teil genommen haben. Alle Schritte sind nun abgeschlossen. Sie können die App jetzt schließen. Sollten wir noch etwas von Ihnen benötigen, werden wir uns mit Ihnen in Verbindung setzen.",
    confirm_info: [
      "Danke, dass Sie Paneem nutzen",
      "Sie haben Ihren Verifizierungsprozess erfolgreich abgeschlossen.",
      "Bitte nehmen Sie sich einen Moment Zeit, um Ihre unten stehenden Kontaktdaten zu bestätigen oder zu aktualisieren.",
    ],
    startVerification: "Starten Sie Ihre Verifikation",
    agreeTermsNotice: "Stimmen Sie den Geschäftsbedingungen zu",
    idsNotice: "Reisepass, Führerschein oder Personalausweis",
    termsText: "Ich habe die Geschäftsbedingungen gelesen und akzeptiere diese.",
    insertEmailTitle: "Geben Sie Ihre Kontaktdaten ein",
    verificationNotice: "Bereiten Sie sich auf Ihre Verifizierung vor",
    consentMsg: "Erteilen Sie uns Ihre Zustimmung",
    url: "https://paneem.claimscon.org/ppgr",
    contactVia: "Kontakt per:",
    phone: "Telefonnummer",
    isSMS: "Können Sie Textnachrichten auf Ihrem Telefon empfangen?",
    yes: "ja",
    no: "Nein",
    country: "Wählen Sie Ihr Land",
    emailLabel: "Email",
    emailExample: "example@example.com",
    consentText:
      "Ich bin damit einverstanden, dass mein Foto aufgenommen wird und dass mein Bild und mein Ausweisdokument in einen Algorithmus umgewandelt und zur Überprüfung meiner Identität verwendet wird.",
    privacyPolicy:
      "Ich verstehe, dass diese Information an die Claims Conference und bestimmte Dritte Firmen übermittelt und in Übereinstimmung mit der Datenschutzerklärung verwendet und gespeichert werden.",
    captureFace: "Tippen Sie auf den Bildschirm, um das Gesicht aufzunehmen.",
    captureDoc: "Tippen Sie auf den Bildschirm, um das Dokument zu erfassen.",
    nextStep:
      "Der nächste Schritt besteht darin, ein Foto Ihres Ausweisdokuments zu machen. Stellen Sie sicher, dass das gesamte Dokument sichtbar ist (das Dokument nicht abgeschnitten ist) und dass das Dokument nah genug erscheint, um den Bildschirm auszufüllen und das Dokumnet lesbar ist.",
    frameFaceOval: "Bitte positionieren Sie Ihr Gesicht im Oval.",
    frameFaceScreen: "Bitte positionieren Sie ihr Gesicht auf dem Bildschirm.",
    send: "Verschicken Sie es",
    retake: "Wiederholen Sie es",
    capture: "Machen Sie ein Foto",
    isDocBack: "Hat Ihr Ausweis eine Rückseite?",
    docBack: "Positionieren Sie die Rückseite des Dokuments so, dass sie vollständig sichbar ist.",
    tryAgain: "Bitte folgen Sie den Anweisungen und versuchen Sie es erneut",
    TakePhotoBackSide: "Machen Sie ein Foto von der Rückseite Ihres Ausweises",
    TakePhotoDocument: "Machen Sie ein Foto von Ihrem Ausweisdokument",
    FrameBackSide: "Fügen Sie die Rückseite Ihres Ausweises in den Rahmen ein",
    FrameDocument: "Fügen Sie Ihr Ausweisdokument in den Rahmen ein",
    welcome: "Willkommen bei PANEEM",
    followInstructions:
      "Bitte folgen Sie den Anweisungen auf dem Bildschirm, und machen ein Foto von sich und Ihrem Ausweis",
    confirmImage: "Bitte bestätigen Sie das Bild",
    documentVisible:
      "Stellen Sie sicher, dass das gesamte Dokument sichtbar ist (Dokument erscheint nicht abgeschnitten). Stellen Sie sicher, dass das Dokument nahe genug erscheint, um den Bildschirm auszufüllen und dass das Dokument auf dem Bild lesbar ist",
    matchingError: "Es gab ein Übereinstimmungsproblem",
    documentVisibleError:
      "Stellen Sie sicher, dass das gesamte Dokument sichtbar ist (Dokument erscheint nicht abgeschnitten). Stellen Sie sicher, dass das Dokument nahe genug erscheint, um den Bildschirm auszufüllen und lesbar ist",
    tryAgainShort: "Versuchen Sie es erneut",
    continue: "Weiter",
    somethingWentWrong: "Etwas ist schief gelaufen",
    internetConnection: "Bitte stellen Sie sicher, dass Ihre Internetverbindung stabil ist",
    FAQ: "Häufig gestellte Fragen",
    instructions: "Anweisungen",
    statusCheck: "Statusprüfung",
    login_clientID: "Agenturen-Portal",
    paneem_not_availble: [
      "Die PANEEM-Anwendung wird derzeit gewartet.",
      "Wir entschuldigen uns für etwaige Unannehmlichkeiten.",
      "Die Anwendung wird in Kürze wieder verfügbar sein. Bitte laden Sie die Seite in ein paar Minuten neu.",
      "Vielen Dank für Ihr Verständnis und Ihre Geduld.",
    ],
    update: "Aktualisieren",
    cancel: "Abbrechen",
    oops: "Ups! Etwas ist schiefgelaufen und Ihre Anfrage konnte nicht bearbeitet werden. Bitte informieren Sie unser Team und versuchen Sie es später noch einmal.",

    formsFeilds: {
      phone: "Telefonnummer",
      email: "E-Mail-Adresse",
      addressTitle: "Adresse",
      address: "Adresse/Straße/Gebäude/Wohnung",
      street: "Straße",
      building: "Gebäude",
      apt: "Wohnung",
      country: "Land",
      city: "Stadt",
      state: "Region/Staat/Provinz",
      zipcode: "Postleitzahl",
    },
    illigble_address: "Bitte geben Sie vollständige Adressdetails an, einschließlich Straße, Stadt und Land.",
    fill_reg_fields: "Hoppla! Etwas ist schiefgelaufen. Bitte geben Sie die Adresse manuell ein.",
    only_english: "Sollte nur englische Buchstaben enthalten",
    find_address: "Adresse finden",
    select_address: "Wählen Sie eine Adresse aus der Liste aus",
    validation: {
      req_feild: "Erforderliches Feld",
      not_number: "Soll keine Ziffern enthalten",
      only_number: "Soll nur Ziffern enthalten",
      digits_char: "Bitte geben Sie eine gültige Postleitzahl ein",
    },
    error_finding_camera:
      "Kann nicht auf die Kamera zugreifen. Stellen Sie sicher, dass sie angeschlossen und nicht von einer anderen Anwendung verwendet wird, und versuchen Sie es dann erneut",
    of_3_attempts: "von 3 Versuchen",
    dont_give_up: "GIB NICHT AUF!",
    threeAttempts: "Sie haben 3 Versuche, den Prozess abzuschließen",
    howToIdentify: "Wie möchten Sie sich identifizieren?",
    regulaLocale: "de",
    previouslyVerified: "Zuvor verifiziert mit PANEEM",
    firstTime: "Erste Anmeldung oder nicht verifiziert mit PANEEM",
    havingTrouble: "Benötigen Sie mehr Zeit?",
    paneemDisabled: [
      "Die Anwendung Paneem wird vom 18. Dezember bis zum 31. Dezember 2025 nicht zur Verfügung stehen, da wir den Lebensnachweiszyklus für 2026 vorbereiten.",
      "Bitte kommen Sie am 1. Januar 2026 oder danach darauf zurück, um Ihre Paneem-Einreichung für 2026 abzuschließen.",
    ],
    cantCapture: "Wir konnten Ihr Foto nicht automatisch aufnehmen",
    manualPhoto: "Ein Foto manuell aufnehmen",
  },

  french: {
    chooseLoginOption: "Choisissez votre méthode d'identification préférée",
    israeliId: "Carte d'identité israélienne",
    israeliId_RESIDENTS: "Carte d'identité israélienne UNIQUEMENT POUR LES RÉSIDENTS D'ISRAËL",
    israeliIdDesc: "Doit comporter exactement 9 chiffres",
    validation_er: {
      missing_address: "Adresse manquante",
      missing_phone: "Numéro de téléphone manquant",
      missing_email: "Adresse e-mail manquante",
    },
    confirm: "Confirmer",
    addres_english_only: "Veuillez saisir l'adresse uniquement en lettres anglaises",
    conutryCode: "Code du pays",
    contactInfoConfirm: {
      par1: "Merci d'avoir mis à jour vos informations de contact.",
      par2: "Pour créer un compte avec la Claims Conference où vos informations personnalisées et services dédiés seront disponibles 24/7",
      par3: "Cliquez ici",
    },
    paneemConfirm: {
      par1: "Merci d'avoir utilisé PANEEM.",
      par2: "Toutes les étapes sont maintenant terminées, vous pouvez fermer l'application.",
      par3: "Si nous avons besoin de quelque chose d'autre de votre part, nous vous contacterons.",
      par4: "Pour créer un compte avec la Claims Conference où vos informations personnalisées et services dédiés seront disponibles 24/7",
      par5: "Cliquez ici",
    },
    textDirection: "ltr",
    language: "french",
    email_or_phone_requered: "Veuillez saisir une adresse e-mail ou un numéro de téléphone pour continuer.",
    form: "Au cours de cette procédure, vous pourrez certifier votre identité en prenant une photo de votre visage et en prenant une photo de votre pièce d'identité officielle avec photo (passeport, permis de conduire ou carte d'identité nationale). Ce système est sécurisé et conforme aux règlements et protections internationaux concernant les données (Pour plus d'informations : lire les conditions générales, fournies lors du processus de vérification). PANEEM est destiné à un usage officiel uniquement.",
    formGreeting: "Bienvenue dans l'application Claims Conference PANEEM.",
    startValidation: "Cliquez pour continuer",
    regNum: "Numéro d'enregistrement",
    regNumDesc: "Doit comporter exactement 6 - 7 chiffres",
    regNumTooltip:
      "Il s'agit du numéro d'enregistrement à sept chiffres à la Claims Conference qui vous a été fourni lors de votre première inscription pour un service ou une demande d'indemnisation. Vous le trouverez également dans la ligne de référence de toute correspondance avec la Claims Conference.",
    regNumError: "Le numéro d'enregistrement comporte moins de 6 - 7 chiffres.",
    birthDate: "Date de naissance",
    birthDateError: "Date invalide.",
    completion:
      "Nous vous remercions d’utiliser PANEEM Toutes les étapes sont maintenant franchies et vous pouvez fermer l’Application Si nous avions besoin d’un complément de votre part, nous vous contacterons",
    confirm_info: [
      "Merci d'utiliser Paneem",
      "vous avez terminé avec succès votre processus de vérification .",
      "Veuillez prendre un moment pour confirmer ou mettre à jour vos coordonnées ci-dessous.",
    ],
    startVerification: "Commencez votre vérification",
    agreeTermsNotice: "Acceptez les conditions générales",
    idsNotice: "Passeport, permis de conduire ou carte nationale d’identité",
    termsText: "J'ai lu et j'accepte les termes et conditions.",
    insertEmailTitle: "Entrez vos coordonnées",
    verificationNotice: "Préparez votre vérification",
    consentMsg: "Acceptez de nous donner votre consentement",
    url: "http://www.claimscon.de/fileadmin/user_upload/dateien/Privacy_Policy_-_French_FINAL__002_.pdf",
    contactVia: "Contacter via:",
    phone: "Numéro de téléphone",
    isSMS: "Pouvez-vous recevoir des SMS sur votre téléphone?",
    yes: "Oui",
    no: "Non",
    country: "Sélectionnez votre pays",
    emailLabel: "Email",
    emailExample: "example@example.com",
    consentText:
      "Je consens à ce que ma photo soit prise et que ma ressemblance et mon document d'identité soient convertis en algorithme et utilisés pour vérifier mon identité.",
    privacyPolicy:
      "Je comprends que ces informations seront transférées à La Claims Conference et à certains tiers et utilisées et stockées conformément à l'avis de confidentialité.",
    captureFace: "Appuyez sur l'écran pour capturer le visage.",
    captureDoc: "Appuyez sur l'écran pour capturer le document.",
    nextStep:
      "La prochaine étape consiste à prendre une photo de votre pièce d’identité. Assurez-vous que le document soit visible en entier (le document n’est pas coupé) et que le document apparaisse suffisamment de près pour remplir l’écran et être lisible.",
    frameFaceOval: "Veuillez placer votre visage dans l’encadrement ovale.",
    frameFaceScreen: "Veuillez placer votre visage dans l’encadrement de l’écran.",
    send: "Envoyer",
    retake: "Reprendre",
    capture: "Prenez la photo",
    isDocBack: "Votre document a-t-il un verso?",
    docBack: "Positionnez le verso du document pour qu’il soit entièrement visible.",
    tryAgain: "Veuillez suivre les instructions et réessayer",
    TakePhotoBackSide: "Prenez une photo du verso de votre pièce d’identité.",
    TakePhotoDocument: "Prenez une photo de votre pièce d’identité.",
    FrameBackSide: "Encadrez le verso du document.",
    FrameDocument: "Encadrez votre pièce d’identité.",
    welcome: "Bienvenue sur PANEEM",
    followInstructions:
      "Veuillez suivre les instructions sur l’écran pour prendre une photo de vous et de votre pièce d’identité",
    confirmImage: "Veuillez confirmer l’image",
    documentVisible:
      "Assurez-vous que l’ensemble du document est visible (le document n’est pas coupé) et que le document apparaît suffisament près pour remplir l’écran et est lisible",
    matchingError: "Il y a eu un problème de correspondance",
    documentVisibleError:
      "Assurez -vous que l’ensemble du document est visible ( le document n’est pas coupé). Assurez-vous que le document apparaît suffisamnet près pour remplir l’écran et est lisible",
    tryAgainShort: "Essayez à nouvau",
    continue: "Veuillez continuer",
    somethingWentWrong: "Quelque chose s’est mal passé",
    internetConnection: "Veuillez vous assurez que votre connection Internet est stable",
    FAQ: "Questions fréquemment posées",
    instructions: "Instructions",
    statusCheck: "Vérification de l'état",
    login_clientID: "Portail des agences",
    paneem_not_availble: [
      "L'application PANEEM est actuellement en maintenance.",
      "Nous nous excusons pour les désagréments occasionnés.",
      "L'application sera bientôt accessible, veuillez actualiser la page dans quelques minutes.",
      "Nous vous remercions de votre compréhension et de votre patience.",
    ],
    update: "Mettre à jour",
    cancel: "Annuler",
    oops: "Oups ! Un problème est survenu et votre demande n'a pas abouti. Veuillez prévenir notre équipe et réessayer plus tard.",
    formsFeilds: {
      phone: "Numéro de téléphone",
      email: "Adresse électronique",
      addressTitle: "Adresse",
      address: "Adresse/Rue/Bâtiment/Appartement",
      street: "Rue",
      building: "Bâtiment",
      apt: "Appartement",
      country: "Pays",
      city: "Ville",
      state: "Région/État/Province",
      zipcode: "Code postal",
    },
    illigble_address: "Veuillez fournir des détails d'adresse complets, y compris la rue, la ville et le pays.",
    fill_reg_fields: "Oups ! Quelque chose s'est mal passé. Veuillez remplir l'adresse manuellement.",
    only_english: "Doit contenir uniquement des lettres anglaises",
    find_address: "Trouver l'adresse",
    select_address: "Sélectionnez une adresse dans la liste",
    validation: {
      req_feild: "Champ obligatoire",
      not_number: "Ne doit pas contenir de chiffres",
      only_number: "Doit contenir uniquement des chiffres",
      digits_char: "Veuillez entrer un code postal valide",
    },
    error_finding_camera:
      "Impossible d'accéder à la caméra. Veuillez vous assurer qu'elle est connectée et non utilisée par une autre application, puis réessayez",
    of_3_attempts: "sur 3 tentatives",
    dont_give_up: "N'ABANDONNEZ PAS!",
    threeAttempts: "Vous avez 3 tentatives pour compléter le processus",
    howToIdentify: "Comment souhaitez-vous vous identifier?",
    regulaLocale: "fr",
    previouslyVerified: "Vérifié précédemment avec PANEEM",
    firstTime: "Première fois ou non vérifié avec PANEEM",
    havingTrouble: "Avez-vous besoin de plus de temps?",
    paneemDisabled: [
      "Le service Paneem sera indisponible du 18 au 31 décembre 2025 en raison des préparatifs de la campagne de preuves de vie de l'année 2026.",
      "Nous vous invitons à revenir à partir du 1er janvier 2026 pour remplir votre demande Paneem 2026.",
    ],
    cantCapture: "Nous n'avons pas pu prendre votre photo de manière automatique",
    manualPhoto: "Prendre une photo manuellement",
  },

  dutch: {
    chooseLoginOption: "Kies uw voorkeursmethode voor identificatie",
    israeliId: "Israëlische ID",
    israeliId_RESIDENTS: "Israelische ID NUR FÜR ISRAELISCHE EINWOHNER",
    israeliIdDesc: "Moet precies 9 cijfers lang zijn",
    validation_er: {
      missing_address: "Adres ontbreekt",
      missing_phone: "Telefoonnummer ontbreekt",
      missing_email: "E-mailadres ontbreekt",
    },
    confirm: "Bevestigen",
    addres_english_only: "Voer het adres alleen in het Engels in",
    conutryCode: "Landcode",
    contactInfoConfirm: {
      par1: "Dank u voor het bijwerken van uw contactgegevens.",
      par2: "Om een account aan te maken bij de Claims Conference waar uw gepersonaliseerde informatie en toegewijde diensten 24/7 beschikbaar zullen zijn.",
      par3: "Klik hier",
    },
    paneemConfirm: {
      par1: "Bedankt voor het gebruik van PANEEM.",
      par2: "Alle stappen zijn voltooid, u kunt de app nu sluiten.",
      par3: "Mochten we nog iets van u nodig hebben, dan nemen we contact op.",
      par4: "Om een account aan te maken bij de Claims Conference waar uw gepersonaliseerde informatie en toegewijde diensten 24/7 beschikbaar zijn.",
      par5: "Klik hier",
    },
    textDirection: "ltr",
    language: "dutch",
    email_or_phone_requered: "Voer alstublieft een e-mailadres of telefoonnummer in om door te gaan.",
    form: "Tijdens deze procedure kunt u uw identiteit bevestigen door een foto van uw gezicht en een foto van een officieel legitimatiebewijs (paspoort, rijbewijs of ID-kaart) te maken. Dit systeem is beveiligd en beantwoordt aan de internationale gegevensbeschermingsvoorwaarden (voor verdere informatie: lees de algemene voorwaarden die tijdens de verificatieprocedure ter beschikking komen). PANEEM is uitsluitend bestemd voor officieel gebruik",
    formGreeting: "Welkom bij de PANEEM-app van Claims Conference",
    startValidation: "Klik om verder te gaan",
    regNum: "Registratienummer",
    regNumDesc: "Moet uit precies 6 - 7 cijfers bestaan",
    regNumTooltip:
      "Dit is het zevencijferige registratienummer van Claim Conference dat aan u werd toegewezen toen u voor de eerste keer een aanvraag indiende voor betalingen of uitkeringen. U vindt het ook in de onderwerpregel van elke correspondentie met Claims Conference.",
    regNumError: "Registratienummer is korter dan 6 - 7 cijfers",
    birthDate: "Geboortedatum",
    birthDateError: "Datum ongeldig",
    completion:
      "Hartelijk dank dat u hebt deelgenomen aan PANEEM. Alle stappen zijn nu voltooid. U kunt de app nu sluiten. Mochten wij nog iets van u nodig hebben, dan nemen wij contact met u op.",
    confirm_info: [
      "Bedankt voor het gebruik van Paneem,",
      "u heeft uw verificatieproces succesvol afgerond.",
      "Neem even de tijd om uw contactgegevens hieronder te bevestigen of bij te werken.",
    ],

    startVerification: "Start uw verificatie",
    agreeTermsNotice: "Stem in met de algemene voorwaarden",
    idsNotice: "Paspoort, rijbewijs of ID-kaart",
    termsText: "Ik heb de algemene voorwaarden gelezen en accepteer ze",
    insertEmailTitle: "Voer uw contactgegevens in",
    verificationNotice: "Bereid u voor op uw verificatie",
    consentMsg: "Ik stem ermee in",
    url: "https://www.claimscon.org/about/privacy-policy/",
    contactVia: "Contact per:",
    phone: "Telefoonnummer",
    isSMS: "Kunt u tekstberichten op uw telefoon ontvangen?",
    yes: "Ja",
    no: "Nee",
    country: "Kies uw land",
    emailLabel: "E-mail",
    emailExample: "example@example.com",
    consentText:
      "Ik ga ermee akkoord dat mijn foto wordt opgenomen en dat mijn foto en mijn legitimatiedocument worden omgezet in een algoritme en worden gebruikt om mijn identiteit na te gaan.",
    privacyPolicy:
      "Ik begrijp dat deze informatie aan de Claim Conference en aan bepaalde derden c.q. bedrijven wordt doorgegeven en in overeenstemming met de privacyverklaring worden gebruikt en opgeslagen.",
    captureFace: "Tik op het beeldscherm om het gezicht op te nemen.",
    captureDoc: "Tik op het beeldscherm om het document vast te leggen",
    nextStep:
      "De volgende stap is het maken van een foto van uw legitimatiedocument. Zorg ervoor dat het hele document zichtbaar is (dat het in zijn geheel op het beeldscherm verschijnt) en dat het document zo dichtbij is dat het hele beeldscherm wordt ingevuld en het document leesbaar is.",
    frameFaceOval: "Plaats uw gezicht in het ovale gedeelte.",
    frameFaceScreen: "Plaats uw gezicht op het beeldscherm.",
    send: "Stuur de foto op.",
    retake: "Herhaal de vorige stappen.",
    capture: "Maak een foto.",
    isDocBack: "Heeft uw legitimatiedocument een achterkant?",
    docBack: "Plaats de achterkant van het document zo dat deze volledig zichtbaar is.",
    tryAgain: "Volg alstublieft de instructies op en probeer het opnieuw",
    TakePhotoBackSide: "Maak een foto van de achterkant van uw legitimatiebewijs.",
    TakePhotoDocument: "Maak een foto van uw legitimatiebewijs.",
    FrameBackSide: "Plaats de achterkant van uw legitimatiebewijs in het frame.",
    FrameDocument: "Plaats uw legitimatiebewijs in het frame",
    welcome: "Welkom bij PANEEM",
    followInstructions:
      "Volg de aanwijzingen op het beeldscherm op en maak een foto van uzelf en uw legitimatiebewijs.",
    confirmImage: "Bevestig de foto.",
    documentVisible:
      "Zorg ervoor dat het hele document zichtbaar is (het document is op het beeldscherm in zijn geheel te zien) en dat het document zo dichtbij is dat het hele beeldscherm wordt gevuld en het document leesbaar is.",
    matchingError: "Er was een matchingprobleem",
    documentVisibleError:
      "Zorg ervoor dat het hele document zichtbaar is (het document is op het beeldscherm in zijn geheel te zien) en dat het document zo dichtbij is dat het hele beeldscherm wordt gevuld en het document leesbaar is.",
    tryAgainShort: "Probeer het opnieuw",
    continue: "Verder",
    somethingWentWrong: "Er is iets misgegaan",
    internetConnection: "Zorg ervoor dat uw internetverbinding stabiel is",
    FAQ: "Vaak gestelde vragen",
    instructions: "Aanwijzingen",
    statusCheck: "Statuscontrole",
    login_clientID: "Agentschappenportaal",
    paneem_not_availble: [
      "De PANEEM-applicatie is momenteel in onderhoud.",
      "Onze excuses voor het eventuele ongemak.",
      "De applicatie zal binnenkort weer beschikbaar zijn, ververs de pagina over een paar minuten.",
      "Dank u voor uw begrip en geduld.",
    ],
    update: "Bijwerken",
    cancel: "Annuleren",
    oops: "Oeps! Er is iets misgegaan en uw verzoek is niet doorgekomen. Waarschuw ons team en probeer het later opnieuw.",
    formsFeilds: {
      phone: "Telefoonnummer",
      email: "E-mailadres",
      addressTitle: "Adres",
      address: "Adres/Straat/Gebouw/Appartement",
      street: "Straat",
      building: "Gebouw",
      apt: "Appartement",
      country: "Land",
      city: "Stad",
      state: "Regio/Staat/Provincie",
      zipcode: "Postcode",
    },
    illigble_address: "Gelieve volledige adresgegevens te verstrekken, inclusief straat, stad en land.",
    fill_reg_fields: "Oeps! Er is iets misgegaan. Vul het adres handmatig in.",
    only_english: "Moet alleen Engelse letters bevatten",
    find_address: "Adres vinden",
    select_address: "Selecteer een adres uit de lijst",
    validation: {
      req_feild: "Verplicht veld",
      not_number: "Mag geen cijfers bevatten",
      only_number: "Moet alleen cijfers bevatten",
      digits_char: "Voer een geldige postcode in",
    },
    error_finding_camera:
      "Kan geen toegang krijgen tot de camera. Zorg ervoor dat deze is aangesloten en niet door een andere toepassing wordt gebruikt, probeer het dan opnieuw",
    of_3_attempts: "van 3 pogingen",
    dont_give_up: "GEEF NIET OP!",
    threeAttempts: "Je hebt 3 pogingen om het proces te voltooien",
    howToIdentify: "Hoe zou je jezelf willen identificeren?",
    regulaLocale: "nl",
    previouslyVerified: "Eerder geverifieerd met PANEEM",
    firstTime: "Eerste keer of niet geverifieerd met PANEEM",
    havingTrouble: "Heb je meer tijd nodig?",
    paneemDisabled: [
      "De toepassing Paneem staat van 18 december t/m. 31 december 2025 niet ter beschikking, omdat wij de cyclus voor het bewijs van in leven zijn voorbereiden.",
      "Wij verzoeken u op 1 januari of daarna daarop terug te komen om uw Paneem-indiening voor 2026 te voltooien.",
    ],
    cantCapture: "Wij konden uw foto niet automatisch opnemen",
    manualPhoto: "Per hand een foto opnemen",
  },

  italian: {
    chooseLoginOption: "Scegli il tuo metodo di identificazione preferito",
    israeliId: "ID israeliana",
    israeliId_RESIDENTS: "ID israeliano SOLO PER I RESIDENTI IN ISRAELE",
    israeliIdDesc: "Deve essere esattamente di 9 cifre",
    validation_er: {
      missing_address: "Indirizzo mancante",
      missing_phone: "Numero di telefono mancante",
      missing_email: "Indirizzo email mancante",
    },
    confirm: "Conferma",
    addres_english_only: "Si prega di digitare l'indirizzo solo in lettere inglesi",
    conutryCode: "Prefisso internazionale",
    contactInfoConfirm: {
      par1: "Grazie per aver aggiornato le tue informazioni di contatto.",
      par2: "Per creare un account con la Claims Conference dove le tue informazioni personalizzate e servizi dedicati saranno disponibili 24 ore su 24, 7 giorni su 7.",
      par3: "Clicca qui",
    },
    paneemConfirm: {
      par1: "Grazie per aver utilizzato PANEEM.",
      par2: "Tutti i passaggi sono completati, ora puoi chiudere l'app.",
      par3: "Se avremo bisogno di qualcos'altro da te, ti contatteremo.",
      par4: "Per creare un account con la Claims Conference dove le tue informazioni personalizzate e servizi dedicati saranno disponibili 24/7",
      par5: "Clicca qui",
    },
    textDirection: "ltr",
    language: "italian",
    email_or_phone_requered: "Si prega di inserire un indirizzo email o un numero di telefono per continuare.",
    form: "Durante questo processo potete confermare la vostra identità facendo una foto del vostro viso e una del vostro documento d'identità rilasciato a livello statale (passaporto, patente di guida o carta d'identità). Questo sistema è protetto e conforme alle norme internazionali sulla protezione dei dati (per maggiori informazioni: leggere i termini e le condizioni forniti durante il processo di verifica). PANEEM è solo per uso ufficiale.",
    formGreeting: "Benvenuti nell'applicazione PANEEM della Claims Conference.",
    startValidation: "Cliccare per continuare",
    regNum: "Numero di registrazione",
    regNumDesc: "Deve essere esattamente di 6 - 7 cifre",
    regNumTooltip:
      "È il numero di registrazione alla Claims Conference di sette cifre che vi è stato assegnato quando avete presentato la prima domanda di prestazioni o di indennizzo. Lo troverete anche nella riga dell'oggetto di ogni lettera di corrispondenza con la Claims Conference.",
    regNumError: "Il numero di registrazione è inferiore a 6 - 7 cifre.",
    birthDate: "Data di nascita",
    birthDateError: "Data non valida.",
    completion:
      "Grazie per aver partecipato a PANEEM. Tutti gli step sono stati completati. Ora potete chiudere l'applicazione. Vi contatteremo nel caso che siano necessarie altre informazioni.",
    confirm_info: [
      "Grazie per aver utilizzato Paneem,",
      "hai completato con successo il processo di verifica.",
      "Prenditi un momento per confermare o aggiornare i tuoi dettagli di contatto di seguito.",
    ],
    startVerification: "Iniziare la verifica",
    agreeTermsNotice: "Accettare i termini e le condizioni",
    idsNotice: "Passaporto, patente di guida o carta d'identità",
    termsText: "Ho letto e accetto i termini e le condizioni.",
    insertEmailTitle: "Inserire i dati di contatto",
    verificationNotice: "Prepararsi per la verifica",
    consentMsg: "Sono d'accordo",
    url: "https://www.claimscon.org/about/privacy-policy/",
    contactVia: "Contatto tramite:",
    phone: "Numero di telefono",
    isSMS: "Potete ricevere messaggi di testo sul  telefono?",
    yes: "Sì",
    no: "No",
    country: "Selezionare il paese",
    emailLabel: "E-mail",
    emailExample: "example@example.com",
    consentText:
      "Acconsento che mi venga fatta la foto e che la mia foto e il mio documento d'identità vengano convertiti in un algoritmo e utilizzati per verificare la mia identità.",
    privacyPolicy:
      "Sono a conoscenza del fatto che queste informazioni saranno trasmesse alla Claims Conference e ad alcune società terze e saranno utilizzate e conservate in conformità con l'Informativa sulla privacy.",
    captureFace: "Toccare lo schermo per registrare il volto.",
    captureDoc: "Toccare lo schermo per registrare il documento.",
    nextStep:
      "Il prossimo step consisterà nel fare una foto del documento d'identità. Accertarsi che sia visibile tutto il documento (il documento non deve essere tagliato), che il documento sia abbastanza vicino da riempire lo schermo e che la scritta sia leggibile.",
    frameFaceOval: "Si prega di posizionare il viso all'interno dell'ovale.",
    frameFaceScreen: "Si prega di posizionare il viso sullo schermo.",
    send: "Inviare",
    retake: "Ripetere",
    capture: "Fare una foto",
    isDocBack: "La carta d'identità ha un retro?",
    docBack: "Posizionare il retro del documento in modo che sia completamente visibile.",
    tryAgain: "Per favore, segui le istruzioni e riprova",
    TakePhotoBackSide: "Fare una foto del retro del documento d'identità",
    TakePhotoDocument: "Fare una foto del documento d'identità",
    FrameBackSide: "Inserire il retro della carta d'identità nella cornice",
    FrameDocument: "Inserire la carta d'identità nella cornice",
    welcome: "Benvenuti in PANEEM",
    followInstructions: "Seguire le istruzioni sullo schermo e fare una foto di sè stessi e del documento d'identità",
    confirmImage: "Confermare la foto",
    documentVisible:
      "Verificare che sia visibile tutto il documento (il documento non deve essere tagliato). Accertarsi che il documento sia abbastanza vicino da riempire lo schermo e che sia leggibile sull'immagine",
    matchingError: "C'è stato un problema di corrispondenza",
    documentVisibleError:
      "Verificare che sia visibile tutto il documento (il documento non deve essere tagliato). Accertarsi che il documento sia abbastanza vicino da riempire lo schermo e che sia leggibile",
    tryAgainShort: "Riprovare",
    continue: "Avanti",
    somethingWentWrong: "Tentativo non riuscito",
    internetConnection: "Accertarsi che la connessione a Internet sia stabile",
    FAQ: "Domande frequenti",
    instructions: "Istruzioni",
    statusCheck: "Controllo dello stato",
    login_clientID: "Portale delle agenzie",
    paneem_not_availble: [
      "L'applicazione PANEEM è attualmente in manutenzione.",
      "Ci scusiamo per gli eventuali disagi.",
      "L'applicazione sarà presto accessibile, si prega di aggiornare la pagina tra qualche minuto.",
      "Apprezziamo la vostra comprensione e pazienza.",
    ],
    update: "Aggiorna",
    cancel: "Annulla",
    oops: "Spiacenti! Qualcosa è andato storto e la tua richiesta non è andata a buon fine. Avvisa il nostro team e riprova più tardi.",
    formsFeilds: {
      phone: "Numero di telefono",
      email: "Indirizzo email",
      addressTitle: "Indirizzo",
      address: "Indirizzo/Strada/Edificio/Appartamento",
      street: "Strada",
      building: "Edificio",
      apt: "Appartamento",
      country: "Paese",
      city: "Città",
      state: "Regione/Stato/Provincia",
      zipcode: "Codice postale",
    },
    illigble_address: "Si prega di fornire dettagli completi dell'indirizzo, inclusi strada, città e paese.",
    fill_reg_fields: "Ops! Qualcosa è andato storto. Si prega di compilare l'indirizzo manualmente.",
    only_english: "Deve contenere solo lettere inglesi",
    find_address: "Trova indirizzo",
    select_address: "Seleziona un indirizzo dall'elenco",
    validation: {
      req_feild: "Campo obbligatorio",
      not_number: "Non deve contenere numeri",
      only_number: "Deve contenere solo numeri",
      digits_char: "Inserisci un CAP valido",
    },
    error_finding_camera:
      "Impossibile accedere alla fotocamera. Assicurati che sia collegata e non utilizzata da un'altra applicazione, quindi riprova",
    of_3_attempts: "di 3 tentativi",
    dont_give_up: "NON ARRENDERTI!",
    threeAttempts: "Hai 3 tentativi per completare il processo",
    howToIdentify: "Come ti piacerebbe identificarti?",
    regulaLocale: "it",
    previouslyVerified: "Verificato precedentemente con PANEEM",
    firstTime: "Prima volta o non verificato con PANEEM",
    havingTrouble: "Hai bisogno di altro tempo?",
    paneemDisabled: [
      "L'applicazione Paneem non sarà disponibile dal 18 dicembre al 31 dicembre 2025 perché stiamo preparando il ciclo di prova di esistenza in vita per il 2026.",
      "La preghiamo di riprendere il 1° gennaio 2026 o successivamente per completare il Suo inoltro a Paneem per il 2026.",
    ],
    cantCapture: "Non abbiamo potuto fare la Sua foto automaticamente",
    manualPhoto: "Fare la foto a mano",
  },

  greek: {
    chooseLoginOption: "Επιλέξτε την προτιμώμενη μέθοδο ταυτοποίησής σας",
    israeliId: "Ισραηλινή ταυτότητα",
    israeliId_RESIDENTS: "Ισραηλινή ταυτότητα ΜΟΝΟ ΓΙΑ ΚΑΤΟΙΚΟΥΣ ΙΣΡΑΗΛ",
    israeliIdDesc: "Πρέπει να είναι ακριβώς 9 ψηφία",
    validation_er: {
      missing_address: "Λείπει η διεύθυνση",
      missing_phone: "Λείπει ο αριθμός τηλεφώνου",
      missing_email: "Λείπει η διεύθυνση email",
    },
    confirm: "Επιβεβαίωση",
    paneemConfirm: {
      par1: "Ευχαριστούμε που χρησιμοποιήσατε το PANEEM.",
      par2: "Όλα τα βήματα έχουν ολοκληρωθεί, και μπορείτε να κλείσετε την εφαρμογή.",
      par3: "Αν χρειαστούμε κάτι άλλο από εσάς, θα επικοινωνήσουμε.",
      par4: "Για να δημιουργήσετε έναν λογαριασμό στη Claims Conference, όπου οι προσωπικές σας πληροφορίες και αφιερωμένες υπηρεσίες θα είναι διαθέσιμες για εσάς 24/7",
      par5: "Κάντε κλικ εδώ",
    },
    contactInfoConfirm: {
      par1: "Ευχαριστούμε που ενημερώσατε τα στοιχεία επικοινωνίας σας.",
      par2: "Για να δημιουργήσετε ένα λογαριασμό στη Claims Conference, όπου οι προσωπικές σας πληροφορίες και αφιερωμένες υπηρεσίες θα είναι διαθέσιμες για εσάς 24/7",
      par3: "Κάντε κλικ εδώ",
    },
    addres_english_only: "Παρακαλώ πληκτρολογήστε τη διεύθυνση μόνο με αγγλικά γράμματα",
    conutryCode: "Κωδικός Χώρας",
    textDirection: "ltr",
    language: "greek",
    email_or_phone_requered: "Παρακαλώ εισάγετε διεύθυνση email ή αριθμό τηλεφώνου για να συνεχίσετε.",
    form: "Στα πλαίσια αυτής της διαδικασίας μπορείτε να προβείτε στην ταυτοποίησή σας, βγάζοντας μια φωτογραφία του προσώπου σας και μια φωτογραφία της ταυτότητάς σας (με φωτογραφία) που έχει εκδοθεί από κρατική αρχή (διαβατήριο, άδεια οδήγησης ή ταυτότητα). Το σύστημα είναι ασφαλές και συμμορφώνεται με τους διεθνείς κανονισμούς προστασίας δεδομένων (για περισσότερες πληροφορίες: διαβάστε τους όρους και τις προϋποθέσεις που παρέχονται κατά τη διαδικασία ταυτοποίησης). Η χρήση του PANEEM προβλέπεται μόνο για επίσημους σκοπούς.",
    formGreeting: "Καλωσορίσατε στην εφαρμογή PANEEM της Διάσκεψης Αξιώσεων.",
    startValidation: "Κάντε κλικ για να προχωρήσετε",
    regNum: "Αριθμός καταχώρησης",
    regNumDesc: "Θα πρέπει να αποτελείται ακριβώς από 6 - 7 ψηφία",
    regNumTooltip:
      "Αυτός είναι ο ψήφιος αριθμός εγγραφής της Διάσκεψης Αξιώσεων που σας αποδόθηκε όταν υποβάλατε την αίτηση για παροχές ή αποζημίωση για πρώτη φορά. Θα τον βρείτε στην γραμμή του θέματος στην αλληλογραφία σας με τη Διάσκεψη Αξιώσεων.",
    regNumError: "Ο αριθμός καταχώρησης έχει λιγότερα από 6 - 7 ψηφία.",
    birthDate: "Ημερομηνία γέννησης",
    birthDateError: "Μη έγκυρη ημερομηνία",
    completion:
      "Ευχαριστούμε για τη συμμετοχή σας στο PANEEM. Όλα τα βήματα έχουν ολοκληρωθεί. Μπορείτε να κλείσετε την εφαρμογή τώρα. Σε περίπτωση που θα χρειαστούμε κάτι από εσάς θα επικοινωνήσουμε μαζί σας.",
    confirm_info: [
      "Σας ευχαριστούμε που χρησιμοποιείτε το Paneem,",
      "ολοκληρώσατε με επιτυχία τη διαδικασία επαλήθευσης.",
      "Παρακαλώ αφιερώστε λίγο χρόνο για να επιβεβαιώσετε ή να ενημερώσετε τα στοιχεία επικοινωνίας σας παρακάτω.",
    ],
    startVerification: "Ξεκινήστε τη διαδικασίας ταυτοποίησης",
    agreeTermsNotice: "Αποδοχή των όρων συναλλαγής",
    idsNotice: "Διαβατήριο, δίπλωμα οδήγησης ή αστυνομική ταυτότητα",
    termsText: "Διάβασα και αποδέχομαι τους όρους συναλλαγής.",
    insertEmailTitle: "Καταχωρήστε τα στοιχεία επικοινωνίας",
    verificationNotice: "Προετοιμαστείτε για την ταυτοποίηση",
    consentMsg: "Συμφωνώ",
    url: "https://www.claimscon.org/about/privacy-policy/",
    contactVia: "Επικοινωνία μέσω",
    phone: "Αριθμός τηλεφώνου",
    isSMS: "Μπορείτε να λάβετε μηνύματα SMS στο τηλέφωνό σας;",
    yes: "Ναι",
    no: "Όχι",
    country: "Επιλέξτε τη χώρα σας",
    emailLabel: "Ηλεκτρονικό ταχυδρομείο",
    emailExample: "pa.paradeigma@paradeigma.com",
    consentText:
      "Συμφωνώ με τη λήψη φωτογραφίας μου και με την μετατροπή της φωτογραφίας και της ταυτότητάς μου σε αλγόριθμο στα πλαίσια της ταυτοποίησης.",
    privacyPolicy:
      "Κατανοώ ότι τα στοιχεία αυτά θα μεταδοθούν στη Διάσκεψη Αξιώσεων και σε ορισμένες τρίτες εταιρείες και θα χρησιμοποιηθούν και θα αποθηκευτούν σύμφωνα με την Πολιτική Απορρήτου.",
    captureFace: "Πατήστε στην οθόνη για να βγάλετε μια φωτογραφία από το πρόσωπό σας.",
    captureDoc: "Πατήστε στην οθόνη για να βγάλετε μια φωτογραφία από το έγγραφο.",
    nextStep:
      "Στο επόμενο βήμα θα πρέπει να βγάλετε μια φωτογραφία από το έγγραφο ταυτότητας. Βεβαιωθείτε ότι ολόκληρο το έγγραφο είναι ορατό (το έγγραφο δεν πρέπει να έχει περικοπεί) και ότι το έγγραφο εμφανίζεται αρκετά κοντά ώστε να γεμίζει την οθόνη και να είναι ευανάγνωστο.",
    frameFaceOval: "Παρακαλούμε να φαίνεται το πρόσωπό σας στο οβάλ πλαίσιο.",
    frameFaceScreen: "Παρακαλούμε να φαίνεται το πρόσωπό σας στην οθόνη.",
    send: "Αποστολή",
    retake: "Επανάληψη",
    capture: "Βγάλετε μια φωτογραφία",
    isDocBack: "Υπάρχει πίσω σελίδα της ταυτότητας;",
    docBack: "Τοποθετήστε το πίσω μέρος του εγγράφου έτσι ώστε να είναι πλήρως ορατό",
    tryAgain: "Παρακαλώ ακολουθήστε τις οδηγίες και δοκιμάστε ξανά",
    TakePhotoBackSide: "Βγάλτε μια φωτογραφία από την πίσω σελίδα της ταυτότητας.",
    TakePhotoDocument: "Βγάλτε μια φωτογραφία από την ταυτότητά σας.",
    FrameBackSide: "Εισάγετε την πίσω σελίδα της ταυτότητας στο πλαίσιο.",
    FrameDocument: "Εισάγετε το έγγραφο ταυτότητας στο πλαίσιο.",
    welcome: "Καλωσορίσατε στο PANEEM.",
    followInstructions:
      "Παρακαλούμε να ακολουθήσετε τις οδηγίες στην οθόνη και να βγάλετε μια φωτογραφία από τον εαυτό σας και την ταυτότητά σας.",
    confirmImage: "Παρακαλούμε να επιβεβαιώσετε την εικόνα.",
    documentVisible:
      "Βεβαιωθείτε ότι ολόκληρο το έγγραφο είναι ορατό (το έγγραφο δεν πρέπει να έχει περικοπεί). Βεβαιωθείτε ότι το έγγραφο εμφανίζεται αρκετά κοντά ώστε να γεμίζει την οθόνη και να είναι ευανάγνωστο.",
    matchingError: "Υπήρξε πρόβλημα ταίριασμα",
    documentVisibleError:
      "Βεβαιωθείτε ότι ολόκληρο το έγγραφο είναι ορατό (το έγγραφο δεν πρέπει να έχει περικοπεί). Βεβαιωθείτε ότι το έγγραφο εμφανίζεται αρκετά κοντά ώστε να γεμίζει την οθόνη και να είναι ευανάγνωστο.",
    tryAgainShort: "Προσπαθήστε ξανά",
    continue: "Συνέχεια",
    somethingWentWrong: "Κάτι πήγε στραβά",
    internetConnection: "Βεβαιωθείτε ότι η σύνδεση στο διαδίκτυο είναι σταθερή",
    FAQ: "Συχνές Ερωτήσεις",
    instructions: "Οδηγίες",
    statusCheck: "Έλεγχος κατάστασης",
    login_clientID: "Πύλη πρακτορείων",
    paneem_not_availble: [
      "Η εφαρμογή PANEEM βρίσκεται σε συντήρηση.",
      "Ζητούμε συγγνώμη για τυχόν ταλαιπωρία.",
      "Η εφαρμογή θα είναι σύντομα διαθέσιμη, παρακαλώ ανανεώστε τη σελίδα σε λίγα λεπτά.",
      "Εκτιμούμε την κατανόηση και την υπομονή σας.",
    ],
    update: "Ενημέρωση",
    cancel: "Ακύρωση",
    oops: "Ωχ! Κάτι πήγε στραβά και το αίτημά σας δεν ολοκληρώθηκε. Ειδοποιήστε την ομάδα μας και δοκιμάστε ξανά αργότερα.",
    formsFeilds: {
      phone: "Αριθμός τηλεφώνου",
      email: "Διεύθυνση email",
      addressTitle: "Διεύθυνση",
      address: "Διεύθυνση/Οδός/Κτίριο/Διαμέρισμα",
      street: "Οδός",
      building: "Κτίριο",
      apt: "Διαμέρισμα",
      country: "Χώρα",
      city: "Πόλ",
    },
    illigble_address: "Παρακαλώ δώστε πλήρεις λεπτομέρειες διεύθυνσης, συμπεριλαμβανομένων οδού, πόλης και χώρας.",
    fill_reg_fields: "Ουπς! Κάτι πήγε στραβά. Παρακαλώ συμπληρώστε τη διεύθυνση χειροκίνητα.",
    only_english: "Πρέπει να περιέχει μόνο αγγλικά γράμματα",
    find_address: "Βρείτε διεύθυνση",
    select_address: "Επιλέξτε μια διεύθυνση από τη λίστα",
    validation: {
      req_feild: "Απαιτούμενο πεδίο",
      not_number: "Δεν πρέπει να περιέχει ψηφία",
      only_number: "Πρέπει να περιέχει μόνο ψηφία",
      digits_char: "Παρακαλώ εισάγετε έγκυρο ταχυδρομικό κώδικα",
    },
    error_finding_camera:
      "Αδύνατη η πρόσβαση στην κάμερα. Βεβαιωθείτε ότι είναι συνδεδεμένη και δεν χρησιμοποιείται από άλλη εφαρμογή, στη συνέχεια δοκιμάστε ξανά",
    of_3_attempts: "από 3 προσπάθειες",
    dont_give_up: "ΜΗΝ ΤΑ ΠΑΡΑΤΑΣ!",
    threeAttempts: "Έχετε 3 προσπάθειες για να ολοκληρώσετε τη διαδικασία",
    howToIdentify: "Πώς θα θέλατε να προσδιοριστείτε;",
    regulaLocale: "el",
    previouslyVerified: "Επαληθεύτηκε προηγουμένως με το PANEEM",
    firstTime: "Πρώτη φορά ή δεν επαληθεύτηκε με το PANEEM",
    havingTrouble: "Χρειάζεστε περισσότερο χρόνο?",
    paneemDisabled: [
      "Η εφαρμογή PANEEM δεν θα βρίσκεται στη διάθεση από 18 Δεκεμβρίου μέχρι και 31 Δεκεμβρίου 2025 επειδή προετοιμάζουμε τον κύκλο απόδειξης ζωής για το 2026.",
      "Παρακαλούμε να επανέλθετε την 1η Ιανουαρίου ή και μετά για να περατώσετε την υποβολή του Paneem σας για το 2026.",
    ],
    cantCapture: "Δεν μπορέσαμε να βγάλουμε αυτόματα τη φωτογραφίας σας",
    manualPhoto: "Βγάλετε μια φωτογραφία χειροκίνητα",
  },
};

export const languages = [
  { language: "english", display: "English" },
  { language: "hebrew", display: "עברית" },
  { language: "russian", display: "Pусский" },
  { language: "german", display: "Deutsch" },
  { language: "french", display: "Français" },
  { language: "dutch", display: "Nederlands" },
  { language: "italian", display: "Italiano" },
  { language: "greek", display: "Ελληνικά" },
];
